import React from 'react';

import i18n from '../../i18n';

// @mui
import {
    TextField,
} from '@mui/material';

export default class DialogNumberField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            helperText: ''
        };
    }

    handleChange = (event) => {
        const value = event.target.value;
        if (!isNaN(value)) {
            this.setState({ error: false, helperText: '' });
            this.props.onChange(event.target.id, value);
        } else {
            this.setState({ error: true, helperText: i18n.t('errors.invalidNumber') });
        }
    };

    render() {
        // field, value, cache, onChange
        let translatedName = i18n.t(`columns.${this.props.field.label}`);

        return (<TextField
            key={this.props.field.label}
            autoFocus
            margin="dense"
            id={this.props.field.id}
            type="number"
            label={translatedName}
            error={this.state.error}
            helperText={this.state.helperText}
            defaultValue={this.props.value}
            fullWidth
            onChange={(event) => this.handleChange(event)}
        />
        );
    }
}
